import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        let formState = false;
        const $formContent = this.element.querySelector('[data-cancel-participants-form="content"]');
        const $openForm = this.element.querySelector('[data-cancel-participants-form="openForm"]');
        const $cancelForm = this.element.querySelector('[data-cancel-participants-form="cancelForm"]');
        const $activeUI = this.element.querySelector('[data-cancel-participants-form="activeUI"]');
        const $disabledUI = this.element.querySelector('[data-cancel-participants-form="disabledUI"]');

        const handleFormState = () => {
            if (formState) {
                $activeUI.classList.remove('is--hidden');
                $disabledUI.classList.add('is--hidden');
                $formContent.classList.add('cancel-participants-form__content--active');
            } else {
                $activeUI.classList.add('is--hidden');
                $disabledUI.classList.remove('is--hidden');
                $formContent.classList.remove('cancel-participants-form__content--active');
            }
        };

        $openForm.onclick = () => {
            formState = true;
            handleFormState();
        };

        $cancelForm.onclick = () => {
            formState = false;
            handleFormState();
        };
    }
}
